/* eslint-disable import/no-cycle */
import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { createResponsiveStateReducer } from 'redux-responsive';
import auth, { State as AuthState } from './auth';
import locations from './locations';
import messages from './messages';
import search, { State as SearchState } from './search';
import consents, { State as ConsentsState } from './consents';
import seasonTicketForm from './forms/seasonTickets';
import checkout, { State as CheckoutState } from './forms/checkout';
import payments, { State as PaymentsState } from './payments';
import ui, { State as UIState } from './ui';
import brand, { State as BrandState } from './brand';
import vehicle, { State as VehicleState } from './vehicle';
import withdrawals, { State as WithdrawalsState } from './withdrawals';
import { reducer as form } from '../components/Decorators/form';
import features, { State as FeatureState } from './features';
import geolocation, { State as GeolocationState } from './geolocation';
import breakpoints from './browser';
import profile, { State as ProfileState } from './forms/profile';
import snackbar, { State as SnackbarState } from './snackbar';
import bookingsMade, { State as BookingsMadeState } from './bookingsMade';
import bookingSlice from './booking';
import bookingPaymentsSlice from './bookingPayments';

export type State = {
  payments: PaymentsState,
  checkout: CheckoutState,
  consents: ConsentsState,
  search: SearchState,
  auth: AuthState,
  geolocation: GeolocationState,
  browser: any,
  brand: BrandState,
  ui: UIState,
  vehicle: VehicleState,
  withdrawals: WithdrawalsState,
  profile: ProfileState,
  snackbar: SnackbarState,
  bookingsMade: BookingsMadeState,
  features: FeatureState
};

export type Store = {
  getState: () => State
};

export const reducers = history => ({
  router: connectRouter(history),
  auth,
  payments,
  checkout,
  features,
  locations,
  messages,
  search,
  consents,
  browser: createResponsiveStateReducer(breakpoints),
  seasonTicketForm,
  form,
  geolocation,
  brand,
  ui,
  vehicle,
  withdrawals,
  profile,
  snackbar,
  bookingsMade,
  [bookingSlice.name]: bookingSlice.reducer,
  [bookingPaymentsSlice.name]: bookingPaymentsSlice.reducer
});

export default history => combineReducers(reducers(history));
